module.exports = __webpack_public_path__ + "static/media/recarga-300x300.a4764645.jpg";